import axios from 'axios';

export default {
  state: {
    blog_detail: {},
    loading: false,
    error: null,
    blog_detailLoaded: false,
    noMoreBlog_detail: false
  },
  mutations: {
    SET_BLOG_DETAIL(state, blog_detail) {
      state.blog_detail = blog_detail;
      state.blog_detailLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_BLOG_DETAIL_LOADING(state, status) {
      state.blog_detailLoading = status;
    },
    UNSET_BLOG_DETAIL(state) {
      state.blog_detailLoaded = false;
      state.blog_detailLoading = false;
      state.blog_detail = {};
    },
    SET_BLOG_DETAIL_ERROR(state, error) {
      state.blog_detailError = error;
    }
  },
  actions: {
    async fetchBlog_detail({ commit, state }, id) {
      commit('UNSET_BLOG_DETAIL');

      try {
        commit('SET_BLOG_DETAIL_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/blog/'+id+'/');
        commit('SET_BLOG_DETAIL', response.data.data);
        commit('SET_BLOG_DETAIL_ERROR', null);
      } catch (error) {
        commit('SET_BLOG_DETAIL_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching blog_detail:', error);
      } finally {
        commit('SET_BLOG_DETAIL_LOADING', false);
      }
    }
  },
  getters: {
    blog_detail: state => state.blog_detail,
    blog_detailLoading: state => state.blog_detailLoading,
    blog_detailError: state => state.blog_detailError,
    blog_detailLoaded: state => state.blog_detailLoaded
  }
}